import { modifier } from 'ember-modifier';

/*
  A modifier for elements that will prevent scrolling of the parent element
  when the locked element is scrolled beyond its scrollable bounds.

  Adapted from http://stackoverflow.com/a/16324762 and https://gist.github.com/theftprevention/5959411
*/

export default modifier((element, [selector]) => {
  function onWheel(event) {
    function prevent() {
      event.stopPropagation();
      event.preventDefault();
      event.returnValue = false;
      return false;
    }
    let {
      scrollTop,
      scrollHeight
    } = event.currentTarget;
    let delta = event.deltaY;
    let up = delta < 0;
    if (!up && scrollHeight - scrollTop === el.clientHeight) {
      // Scrolling down, but this will take us past the bottom
      el.scrollTop = scrollHeight;
      return prevent();
    } else if (up && scrollTop === 0) {
      // Scrolling up, but this will take us past the top
      el.scrollTop = 0;
      return prevent();
    }
    return;
  }
  let el = selector ? element.querySelector(selector) : element;
  if (!el) {
    return;
  }
  el.addEventListener('wheel', onWheel);
  return () => el.removeEventListener('wheel', onWheel);
});